/** This will load agents for large agencies in the background */
import { getPlanChangeForAgencyID, getPlanChangeForDirectorID } from "../GraphQl/BDSWebService";
import * as Sentry from "@sentry/browser";

const ProductionLoader = {
  loadPlanChangeForAgencyID,
  loadPlanChangeForDirectorID,
};

// async function loadProduction(agencyId, year, level) {
//   //const increment = 4000;
//   //const res = await loadChunk(agencyId, year, level, agentId, increment, 0, []);
//   try {
//     const res = await getProductionStatisticsGql(
//       parseInt(agencyId),
//       parseInt(year),
//       level,
//       null,
//       null
//     );
//     return res;
//   } catch (e) {
//     Sentry.captureMessage(
//       "Production Loader error: " + e.message,
//       Sentry.Severity.Error
//     );
//   }
// }

async function loadPlanChangeForDirectorID(directorId, year) {
  try {
    const res = await getPlanChangeForDirectorID(
      directorId,
      parseInt(year),
    );
    return res;
  } catch (e) {
    Sentry.captureMessage(
      "Plan Change Loader error: " + e.message,
      Sentry.Severity.Error
    );
  }
}

async function loadPlanChangeForAgencyID(agencyId, year) {
  try {
    const res = await getPlanChangeForAgencyID(
      parseInt(agencyId),
      parseInt(year),
    );
    return res;
  } catch (e) {
    Sentry.captureMessage(
      "Plan Change Loader error: " + e.message,
      Sentry.Severity.Error
    );
  }
}

export default ProductionLoader;
